Vue.component('vue-carousel', {
    delimiters: ['${', '}'],

    template: '#vue-carousel-template',

    props: [
        'color', 'items', 'highlight_center',
    ],

    data() {
        return {
            is_scrolling_left: false,
            is_scrolling_right: false,
            scroll_duration: 350,
            starting_index: 0,
            visible_count: Math.min(3, this.items.length),
        }
    },

    computed: {
        ending_index() {
            return this.starting_index + this.visible_count - 1;
        },
        has_next_item() {
            return this.ending_index < this.items.length - 1;
        },
        has_previous_item() {
            return this.starting_index > 0;
        },
        highlight_center_slide() {
            return this.highlight_center && this.visible_count > 1 && this.visible_count % 2 > 0;
        },
        highlighted_index() {
            return Math.ceil(this.visible_count / 2) - 1;
        },
        is_scrolling() {
            return this.is_scrolling_left || this.is_scrolling_right;
        },
        next_item() {
            let hide_item = { hidden: true };

            return this.ending_index < this.items.length - 1 ?
                Object.assign(hide_item, this.items[this.ending_index + 1]) :
                hide_item;
        },
        previous_item() {
            let hide_item = { hidden: true };

            return this.starting_index > 0 ?
                Object.assign(hide_item, this.items[this.starting_index - 1]) :
                hide_item;
        },
        scroller_width_percent() {
            return 100 + this.scroller_margin_percent_for_hiding * 2;
        },
        scroller_margin_percent_for_hiding() {
            return 100 / this.visible_count;
        },
        scroller_is_scrolling_margin() {
            return this.is_scrolling_left ? 2 * this.scroller_margin_percent_for_hiding : 0;
        },
        scroller_styles() {
            if (this.is_scrolling) {
                return {
                    width: this.scroller_width_percent + '%',
                    marginLeft: '-' + this.scroller_is_scrolling_margin + '%',
                    transition: 'margin ' + this.scroll_duration + 'ms ease-in-out',
                }
            } else {
                return {
                    width: this.scroller_width_percent + '%',
                    marginLeft: '-' + this.scroller_margin_percent_for_hiding + '%',
                    transition: 'none',
                }
            }
        },
        show_buttons() {
            return this.visible_count != this.items.length;
        },
        slides() {
            return [this.previous_item].concat(this.visible_items).concat([this.next_item]);
        },
        visible_items() {
            return this.items.slice(this.starting_index, this.ending_index + 1);
        },
    },

    methods: {
        showNext() {
            if (! this.is_scrolling && this.has_next_item) {
                this.scrollLeft().then(() => {
                    this.starting_index = this.starting_index + 1;
                });
            }
        },
        showPrevious () {
            if (! this.is_scrolling && this.has_previous_item) {
                this.scrollRight().then(() => {
                    this.starting_index = this.starting_index - 1;
                });
            }
        },
        scrollLeft () {
            return new Promise((resolve, reject) => {
                this.is_scrolling_left = true;

                setTimeout(() => {
                    this.is_scrolling_left = false;
                    resolve();
                }, this.scroll_duration);
            });
        },
        scrollRight () {
            return new Promise((resolve, reject) => {
                this.is_scrolling_right = true;

                setTimeout(() => {
                    this.is_scrolling_right = false;
                    resolve();
                }, this.scroll_duration);
            });
        },
    },
});
